/// <amd-module name="DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Actions/PipelinesAuthorizationActionsHub" />
import { Action } from "VSS/Reflux/Action";
import { ResourcePipelinePermissions } from "PipelineChecks/Authorization/Client/Contracts/PipelinePermissions";
import { BuildDefinitionReference } from "DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/Build/Contracts/Build";

export class PipelinesAuthorizationActionsHub {

    constructor() {
        this.initialize();
        this._toggleAllPipelinesRestriction = new Action<ResourcePipelinePermissions>();
        this._initializeAuthorizedDefinitions = new Action<ResourcePipelinePermissions>();
        this._initializeAllPipelineDefinitions = new Action<BuildDefinitionReference[]>();
        this._initializeAuthorizedPipelineDefinitions = new Action<BuildDefinitionReference[]>();
        this._setErrorMessage = new Action<string>();
    }
    public static getKey(): string {
        return "pipelines-security-actions";
    }

    public initialize(instanceId?: string): void {
    }

    public get toggleAllPipelinesRestriction(): Action<ResourcePipelinePermissions> {
        return this._toggleAllPipelinesRestriction;
    }

    public get initializeAuthorizedDefinitions(): Action<ResourcePipelinePermissions> {
        return this._initializeAuthorizedDefinitions;
    }

    public get initializeAllPipelineDefinitions(): Action<BuildDefinitionReference[]> {
        return this._initializeAllPipelineDefinitions;
    }

    public get initializeAuthorizedPipelineDefinitions(): Action<BuildDefinitionReference[]> {
        return this._initializeAuthorizedPipelineDefinitions;
    }

    public get setErrorMessage(): Action<string> {
        return this._setErrorMessage;
    }

    private _toggleAllPipelinesRestriction: Action<ResourcePipelinePermissions>;
    private _initializeAuthorizedDefinitions: Action<ResourcePipelinePermissions>;
    private _initializeAllPipelineDefinitions: Action<BuildDefinitionReference[]>;
    private _initializeAuthorizedPipelineDefinitions: Action<BuildDefinitionReference[]>;
    private _setErrorMessage: Action<string>;
}
